/**
 * ReportTipSheet — same 8 reasons as posts. Kept as its own file so
 * it can be imported by any surface (tips, comments, marketplace listings)
 * without pulling the entire Community.jsx page.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const REASONS = [
  { id: "spam", label: "Spam or scam" },
  { id: "inappropriate", label: "Inappropriate content" },
  { id: "harassment", label: "Harassment or bullying" },
  { id: "hate_speech", label: "Hate speech" },
  { id: "nudity", label: "Nudity or sexual content" },
  { id: "self_harm", label: "Self-harm or suicide" },
  { id: "impersonation", label: "Impersonation" },
  { id: "misinformation", label: "False or misleading information" },
];

export default function ReportTipSheet({ onCancel, onSubmit, label = "tip" }) {
  const [reason, setReason] = useState(null);
  const [detail, setDetail] = useState("");
  const nav = useNavigate();
  return (
    <div
      className="fixed inset-0 z-[60] grid place-items-end sm:place-items-center bg-black/50"
      data-testid="report-sheet"
    >
      <div className="w-full sm:max-w-md bg-white rounded-t-[20px] sm:rounded-[20px] p-5 max-h-[85vh] overflow-y-auto">
        <h3 className="font-display text-[22px]">Report {label}</h3>
        <p className="text-[13px] text-ink-soft mt-1">Why are you reporting this?</p>
        <div className="space-y-2 mt-3">
          {REASONS.map((r) => (
            <button
              key={r.id}
              onClick={() => setReason(r.id)}
              data-testid={`report-${r.id}`}
              className="w-full px-4 h-11 rounded-[12px] border text-left text-[14px] font-medium"
              style={{
                borderColor: reason === r.id ? "#00D4FF" : "var(--border, rgba(12,12,11,0.16))",
                background: reason === r.id ? "rgba(0,212,255,0.08)" : "transparent",
              }}
            >
              {r.label}
            </button>
          ))}
        </div>
        <textarea
          data-testid="report-detail"
          value={detail}
          onChange={(e) => setDetail(e.target.value.slice(0, 200))}
          placeholder="Optional detail (200 chars)…"
          rows={2}
          className="w-full mt-3 p-3 rounded-[12px] border border-line2 text-[13px] outline-none"
        />
        <div className="text-right text-[11px] text-ink-soft mt-1">{detail.length}/200</div>
        <button
          onClick={() => reason && onSubmit(reason, detail || null)}
          disabled={!reason}
          data-testid="report-submit"
          className="w-full mt-2 h-12 rounded-pill disabled:opacity-50"
          style={{ background: "#0C0C0B", color: "#F4F3F1", borderRadius: 100, fontWeight: 700 }}
        >
          Submit report
        </button>
        <button
          onClick={() => { onCancel(); nav("/community/rules"); }}
          data-testid="report-see-rules"
          className="w-full mt-2 h-10 text-[13px] font-medium"
          style={{ color: "var(--text-secondary, #4A4845)", background: "transparent" }}
        >
          See our community rules
        </button>
        <button
          onClick={onCancel}
          className="w-full mt-1 h-10 rounded-pill text-[13px] text-ink-soft"
          style={{ borderRadius: 100 }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
